export function layoutLeftToRight(model, opts = {}) {
  const {
    padding = 40,
    nodeWidth = 220,
    nodeHeight = 72,
    colGap = 80,
    rowGap = 24,
  } = opts;

  const stageOrder = Array.isArray(model?.stageOrder) ? model.stageOrder : [];
  const employees = Array.isArray(model?.employees) ? model.employees : [];

  const nodes = [];
  const edges = [];

  const empCount = employees.length;
  const totalHeight =
    empCount > 0
      ? padding * 2 + empCount * nodeHeight + (empCount - 1) * rowGap
      : padding * 2 + nodeHeight;

  const rootX = padding;
  const rootY =
    empCount > 0
      ? padding + ((empCount - 1) * (nodeHeight + rowGap)) / 2
      : padding;

  nodes.push({
    id: "root",
    type: "root",
    label: "Jobs Opened",
    value: model?.root?.totalJobsOpen ?? 0,
    x: rootX,
    y: rootY,
    width: nodeWidth,
    height: nodeHeight,
    payload: { type: "root" },
  });

  const empX = rootX + nodeWidth + colGap;

  employees.forEach((emp, idx) => {
    const y = padding + idx * (nodeHeight + rowGap);
    const empId = String(emp?.employeeId ?? "");
    const empNodeId = `emp:${empId}`;

    nodes.push({
      id: empNodeId,
      type: "employee",
      label: emp?.employeeName ?? empId,
      value: emp?.jobsOpenCount ?? 0,
      x: empX,
      y,
      width: nodeWidth,
      height: nodeHeight,
      payload: { type: "employee", employeeId: empId },
    });

    edges.push({ id: `e:root->${empNodeId}`, from: "root", to: empNodeId });

    const stageBaseX = empX + nodeWidth + colGap;

    stageOrder.forEach((stageName, sIdx) => {
      const stageNodeId = `stage:${empId}:${stageName}`;
      const x = stageBaseX + sIdx * (nodeWidth + colGap);
      const count = emp?.stageCounts?.[stageName] ?? 0;

      nodes.push({
        id: stageNodeId,
        type: "stage",
        label: stageName,
        value: count,
        x,
        y,
        width: nodeWidth,
        height: nodeHeight,
        payload: { type: "stage", employeeId: empId, stageName },
      });

      const prevId =
        sIdx === 0 ? empNodeId : `stage:${empId}:${stageOrder[sIdx - 1]}`;
      edges.push({
        id: `e:${prevId}->${stageNodeId}`,
        from: prevId,
        to: stageNodeId,
      });
    });
  });

  const lastColX =
    empX +
    nodeWidth +
    colGap +
    Math.max(0, stageOrder.length - 1) * (nodeWidth + colGap);
  const contentWidth = lastColX + nodeWidth + padding;
  const contentHeight = totalHeight;

  return {
    nodes,
    edges,
    bounds: { x: 0, y: 0, width: contentWidth, height: contentHeight },
  };
}
